import { createStore, applyMiddleware, compose } from 'redux';
import { thunk } from 'redux-thunk'; // Assuming 'redux-thunk' export 'thunk' as a named export
import allReducers from '../reducers/index';
import initialState from '../reducers/initialState';

const middleware = [thunk]; // Use an array for middleware

// Conditional setup for Redux DevTools
const composeEnhancers =
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose; // Fallback to Redux's default compose

export const store = createStore(
  allReducers,
  initialState,
  composeEnhancers(applyMiddleware(...middleware))
);


